import React from 'react';
import './About.css';
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';

const About = () => {
  return (
    <div className=" flex flex-col min-h-screen">
      <Navbar />
      <div className='about-container'>
        <div className="about-header">
          {/* <div className="breadcrumb">
            <span>Home</span>
            <span className="separator">|</span>
            <span>About</span>
          </div> */}

          <div className="header-content">
            <div className="title-section">
              <div className="subtitle">
                <span>通过专业数据洞察赋能行业变革</span>
              </div>
              <h1 className="main-title">
                关于数瑞科技
              </h1>
            </div>

            <div className="description">
              <p className="company-intro">
                海南数瑞科技是一家致力于跨境贸易、海关报关、投资与风险管理、证券市场解决方案的综合性科技企业。公司依托自研的跨境贸易智能管理平台、合规风控系统、进出口自动化报关与税务筹划工具、以及投资/证券领域的智能分析与决策产品，帮助全球贸易商和投资机构在高效管理业务的同时规避复杂风险。

                凭借对国际贸易政策、多国关税法规以及金融市场的深度理解，海南数瑞科技为客户提供从进出口业务规划、海外物流追踪、财务结算与税务筹划、海关合规审查、投融资风控到股票与证券动态监测的全流程数字化软件解决方案。坐落于海南自由贸易港，团队由资深外贸专家、海关政策专员、金融量化分析师以及软件工程师共同组成，借助自贸港的政策与资源优势，持续为企业与机构赋能，实现全球业务的智慧化管理。

              </p>
            </div>
          </div>
        </div>

        <div className="about-image">
          <img src="/images/about/image.png" alt="数据分析展示" />

        </div>
      </div>

      <div className="mission-vision-section">
        <div className="mission-vision-image">
          <img src="/images/about/image2.png" alt="数据分析技术" />
        </div>


        <div className="mission-vision-content">
          <div className="mission-box">
            <h2>企业使命</h2>
            <p>
              海南数瑞科技始终专注于利用数字化与智能化手段，为企业提供灵活高效的跨境贸易流程管理与合规支持；同时在投资与风险管理领域，帮助客户洞察市场机遇、降低投融资风险。通过深度整合贸易与金融生态资源，实现产业链与价值链的整体提升。

            </p>
          </div>

          <div className="vision-box">
            <h2>企业愿景</h2>
            <p>
              随着海南自贸港政策的不断深化，海南数瑞科技致力于借助地区及技术优势，打造覆盖全球、链接多领域的跨境贸易与投资生态平台，成为企业、机构与投资者通往世界、掌控风险、获取机遇的可信赖合作伙伴。

            </p>
          </div>
        </div>
      </div>

      <div className='mt-auto' style={{ backgroundColor: '#f8f9fa' }}>
        <div className='container'>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default About; 